/// <reference types="vite/client" />

import { GA_MEASUREMENT_ID, gaEnabled, getGtag } from "./tracking";
import { trackPageView } from "./tracking";

export { trackPageView };

export function setUserId(userId: string | null) {
  if (!gaEnabled()) return;
  const gtag = getGtag();
  if (!gtag) return;

  try {
    gtag("config", GA_MEASUREMENT_ID, {
      user_id: userId ?? undefined,
    });
  } catch {
    // fail silently
  }
}

export function trackLogin(method = "password") {
  if (!gaEnabled()) return;
  const gtag = getGtag();
  if (!gtag) return;

  try {
    gtag("event", "login", { method });
  } catch {
    // fail silently
  }
}

export function trackLogout() {
  if (!gaEnabled()) return;
  const gtag = getGtag();
  if (!gtag) return;

  try {
    gtag("event", "logout");
  } catch {
    // fail silently
  }
}
